import React from "react";
import "./Input.css";

interface InputProps {
  type: string;
  label?: string;
  placeholder?: string;
  value: string;
  name?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  search?: boolean;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  required?: boolean;
  onClickEndIcon?: () => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  autoComplete?: string;
  disabled?: boolean;
  error?: string;
}

const Input: React.FC<InputProps> = ({
  type,
  label,
  placeholder,
  value,
  name,
  onChange,
  search = false,
  startIcon,
  endIcon,
  required = false,
  onClickEndIcon,
  onFocus,
  onClick,
  onKeyPress,
  autoComplete,
  disabled,
  error,
}) => {
  const inputId = name || `input-${label}`;
  const errorId = `${inputId}-error`;

  return (
    <div className="input-container">
      {label && (
        <label htmlFor={inputId} className="input-label">
          {label} {required && <span className="required">*</span>}
        </label>
      )}

      <div className={`input-wrapper`}>
        {startIcon && (
          <span
            className={`start-icon ${
              search ? "removeRightBorder" : "addRightBorder"
            }`}
          >
            {startIcon}
          </span>
        )}
        <input
          id={inputId}
          className={`custom-input ${search ? "input-search" : ""}`}
          type={type}
          placeholder={placeholder}
          value={value}
          name={name}
          onChange={onChange}
          required={required}
          onFocus={onFocus}
          onClick={onClick}
          onKeyPress={onKeyPress}
          autoComplete={autoComplete}
          disabled={disabled}
          aria-invalid={error ? "true" : "false"} // ✅ WCAG
          aria-describedby={error ? errorId : undefined}
        />
        {endIcon && (
          <span className="input-icon end-icon" onClick={onClickEndIcon}>
            {endIcon}
          </span>
        )}
      </div>
      {error && (
        <p
          id={errorId}
          className="error-text"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;
